import React from 'react';
import {
  List,
  Responsive,
  Filter,
  TextInput,
  DateField,
  SimpleList,
  Datagrid,
  TextField,
  NumberField,
  DateInput,
  ReferenceInput,
  SelectInput
} from "react-admin";

export const PesajeFilterList = props => (
  <Filter {...props}>
    <TextInput label="Bolsón" source="bolson" autoFocus />
    <TextInput label="Recuperador" source="cartoneroNombre" autoFocus />
    <DateInput label="Fecha" source="fecha" autoFocus />
    <ReferenceInput reference="etapas" source="etapa" perPage={100} sort={{ field: 'nombre', order: 'ASC' }}>
        <SelectInput  optionText="nombre" optionValue="nombre" />
    </ReferenceInput>
    <ReferenceInput reference="predios" source="predio">
      <SelectInput  optionText="nombre" optionValue="_id" />
    </ReferenceInput>
  </Filter>
);

export class PesajeListComponent extends React.Component {
  render() {
    const props = this.props;
    return(
      <List
        {...props}
        bulkActions={false}
        // eslint-disable-next-line
        sort={{ field: "fecha", order: "DESC" },{ field: "bolson", order: "ASC" }}
        filters={<PesajeFilterList />}
        exporter={false}
      >
        <Responsive
          small={
            <SimpleList
              primaryText={record => record.cartoneroNombre }
              secondaryText={record => new Date(record.fecha).toLocaleDateString("es-AR") + " Bolson: " + record.bolson
              }
              tertiaryText={record => record.peso + "Kgs."}
            />
          }
          medium={
            <Datagrid>
              <DateField label="Fecha" source="fecha" />
              <TextField label="Recuperador" source="cartoneroNombre" />
              <TextField label="D.N.I." source="dni" />
              <TextField source="etapa" />
              <NumberField label="Número de bolsón" source="bolson" />
              <NumberField label="Peso (Kgs.)" source="peso" />
              <TextField label="Comentario" source="comentario" />
              <TextField label="Pesador" source="pesadorNombre" />
              <DateField label="Actualizado" source="updatedAt" />
            </Datagrid>
          }
        />
      </List>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pesajes/PesajeListComponent.js